import { VisibilityOff as Icon } from '@mui/icons-material';
import type { SxProps } from '@mui/material';
import { Chip } from '@mui/material';
import type { FC } from 'react';

export const NotPublicChip: FC<{ sx?: SxProps }> = ({ sx }) => (
  <Chip color="info" label="Private" size="small" icon={<Icon />} sx={sx} />
);
